import { SVGAttributes } from "react";

export const RemoveFormattingIcon = (
  props: SVGAttributes<SVGElement> & { size: "regular" }
) => {
  return (
    <svg
      width={24}
      height={24}
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M11.537 7l-2-2H19a1 1 0 011 1v2a1 1 0 11-2 0V7h-4v2.463l-2-2V7h-.463zM5.911 4.774l.281.28c.032.046.069.09.11.13L19.34 18.223c.277.39.24.93-.119 1.27a.996.996 0 01-1.41 0L15.916 17.6A1 1 0 0115 19h-4a1 1 0 110-2h1v-3.318L7.278 8.961A1 1 0 016 8v-.317l-1.499-1.5a.996.996 0 111.41-1.41zM14 15.683V17h1c.143 0 .278.03.401.084L14 15.682z"
        fill="currentColor"
      />
    </svg>
  );
};
RemoveFormattingIcon.displayName = "RemoveFormattingIcon";
